<template>
	<mounting-portal :mount-to="mount">
		<div class="grid md:grid-cols-2 gap-4 md:gap-6 mt-4 md:mt-6">
			<a 
				:href="`/video/${item.link}`"
				v-for="item,itemIndex in loadedVideos"
				:key="itemIndex"
				class="block w-full relative overflow-hidden mb-8 md:mb-0">

				<video-media
					:src="item.image"
					:alt="item.title_dv" />

				<div class="w-full mt-5 md:absolute md:bottom-0 md:mb-6 md:px-6 pointer-events-none">
					<div class="w-full md:flex md:items-center md:h-20 md:gap-4">
						<div class="order-2 flex-grow">
							<h1 class="font-waheed text-3xl text-white">
								{{ item.title_dv }}
							</h1>
						</div>
						<div class="hidden md:block flex-shrink-0 w-16 order-1">
							<svg 
								class="text-mh-vid-red w-16 h-16 group-hover:scale-125 transform transition duration-300"
								viewBox="0 0 50 50" 
								xmlns="http://www.w3.org/2000/svg">
								<path
									d="M20.534,37.374a1.774,1.774,0,0,1-.817-.2,1.813,1.813,0,0,1-.967-1.611V17.437a1.81,1.81,0,0,1,.967-1.61,1.774,1.774,0,0,1,.817-.2,1.756,1.756,0,0,1,1.035.336l12.493,9.063a1.828,1.828,0,0,1,0,2.95L21.57,37.039A1.759,1.759,0,0,1,20.534,37.374Z"
									data-name="Subtraction 1" id="Subtraction_1" transform="translate(-0.75 -1.626)"
									fill="#fff">
								</path>
								<path
									d="M50,25A25,25,0,1,1,25,0,25,25,0,0,1,50,25ZM21.219,15.916a1.563,1.563,0,0,0-2.469,1.272V32.813a1.562,1.562,0,0,0,2.469,1.272l10.938-7.812a1.562,1.562,0,0,0,0-2.544L21.219,15.916Z"
									fill="currentColor" id="play" transform="translate(0 0)"></path>
							</svg>
						</div>
					</div>
				</div>
			</a>
		</div>

		<div class="w-full flex items-center justify-center mt-4 md:mt-6">
			<button
				@click="loadMoreVideos()"
				v-if="next_page_url"
				class="text-mh-vid-main-gray hover:text-mh-vid-secondary-gray transition ease-in-out duration-300"
				:class="{'animate-bounce' : true === isLoading}">
				<svg data-name="Group 5" xmlns="http://www.w3.org/2000/svg" width="60" height="60"><g fill="currentColor" stroke="#535353" stroke-miterlimit="10"><circle cx="30" cy="30" r="30" stroke="none"/><circle cx="30" cy="30" r="29.5"/></g><circle data-name="Oval Copy 3" cx="3.5" cy="3.5" r="3.5" transform="translate(15 28)" fill="#535353"/><circle data-name="Oval Copy 4" cx="3.5" cy="3.5" r="3.5" transform="translate(27 28)" fill="#535353"/><circle data-name="Oval Copy 5" cx="3.5" cy="3.5" r="3.5" transform="translate(38 28)" fill="#535353"/></svg>
			</button>
		</div>
	</mounting-portal>
</template>

<script>
import VideoMedia from './VideoMedia.vue'

export default {
	props: ["videos", "mount", "type"],

	props: {
		videos: {
			type: Object,
		},
		mount: {
			type: String,
		},
		type: {
			type: String,
		},
		ignore: {
			type: String,
			default: null
		}
	},

	components: {
		VideoMedia,
	},

	data() {
		return {
			isLoading: false,
			loadedVideos: [],
			next_page_url: null,
		};
	},

	computed: {
		subType() {
			if ("section" == this.type) {
				return true;
			}
		},
	},

	methods: {
		loadMoreVideos() {
			this.isLoading = true
			axios
				.post("/video/proxy", {
					next_page: this.next_page_url,
					ignore: this.ignore,
				})
				.then((resp) => {
					if (this.subType) {
						this.loadedVideos.push(...resp.data[0].videos.data);
						this.next_page_url = resp.data[0].videos.next_page_url;
					} else {
						//Checking if the query from featured sub
						if (resp.data.hasOwnProperty("sub")) {
							this.loadedVideos.push(...resp.data.sub.data);
							this.next_page_url = resp.data.sub.next_page_url;
						} else {
							this.loadedVideos.push(...resp.data.data);
							this.next_page_url = resp.data.next_page_url;
						}
					}
				})
				.catch((e) => {
					console.error(e);
				})
				.then(() => {
					this.isLoading = false
				});
		},
	},
	mounted() {
		this.next_page_url = this.videos.next_page_url;
	},
};
</script>s